import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '../../Store/hooks/useStore'
import { $setSelectionStyle } from '../../utils/style'
import { useEditor } from '../useEditor'

export const useFontBackgroundColor = () => {
  const editor = useEditor()
  const { currentFontBackgroundColor, setCurrentFontBackgroundColor } =
    useRichEditorStore(state =>
      pick(state, [
        'currentFontBackgroundColor',
        'setCurrentFontBackgroundColor'
      ])
    )

  return {
    fontBackgroundColor: currentFontBackgroundColor,
    setFontBackgroundColor: value => {
      $setSelectionStyle(editor, {
        backgroundColor: value
      })
      setCurrentFontBackgroundColor(value)
    },
    toggleFontBackgroundColor: () => {
      $setSelectionStyle(editor, {
        backgroundColor: currentFontBackgroundColor
      })
    }
  }
}
